// extracted by mini-css-extract-plugin
export default {"container":"history_container__TbnF3","results":"history_results__Fw75v","result":"history_result__XiMEH"};